import getUserWorkingHours from './getUserWorkingHours';

export default () => getUserWorkingHours().WorkingHoursTimeZoneId;
